// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media only screen and (min-width:992px){.row-goods .swiper-slide{transition:visibility .3s ease-in}.row-goods .swiper-slide:not(.swiper-slide--visible){visibility:hidden}}", ""]);
// Exports
module.exports = exports;
